import { UserIdentityRO } from '@scale/identity-service-fetch-client';
import apiFetch from '@scale/frontend-lib/api-fetch';

export async function getUserIdentities(body: { userIds: string[] }) {
  return await apiFetch<{ users: UserIdentityRO[] }>(null, `internal/user/identities-list`, {
    method: 'POST',
    body,
  });
}
